<script setup lang="ts">
import { Module } from '@/core/collections/modules/module.interface';

const emits = defineEmits<{
   onTabChange: [string];
}>();

const { t } = useI18n();
const { state, dispatch } = useStore();

const userId = computed(() => state.userInfo?.userInfo?.id);
const userModules = ref([] as Array<Module>);
onBeforeMount(async () => {
   if (!userId.value) return;
   userModules.value = await dispatch('user/role/getRoles', userId.value);
});

const tabs = computed(() => {
   const tabs = [t('generic.general')];

   return tabs;
});

const selectedTab = ref(tabs.value[0]);

watch(
   selectedTab,
   (tab) => {
      emits('onTabChange', tab);
   },
   { immediate: true },
);
</script>

<template>
   <div class="settings-menu">
      <div v-for="tab in tabs" :key="tab" class="settings-menu__tab" :class="{ '-active': tab === selectedTab }" @click="selectedTab = tab">
         {{ tab }}
      </div>
   </div>
</template>

<style lang="scss" scoped>
.settings-menu {
   &__tab {
      margin-bottom: 2.5rem;
      font-size: var(--nxt-font-large);
      color: var(--nxt-dark-grey);
      cursor: pointer;
      font-weight: var(--nxt-font-bold);
      &.-active {
         color: var(--nxt-main);
      }
   }
}
</style>
